import { collection, findSelector, resource } from "data/helpers/apiv3";
import { Gear } from "data/records";

const [api, actions] = resource(Gear, [["list", collection.get("", ["userId"])]]);

const selectors = {
  ...findSelector(Gear),
  byUserId: (state, userId) => state.apiv3.gear.id.filter((g) => g.userId === userId),
};

const reducers = {};

const initialState = {};

export {
  api as gearApi,
  actions as gearActions,
  selectors as gearSelectors,
  reducers as gearReducers,
  initialState as gearInitialState,
};
